export enum ComputationMethodType {
  arithmeticAverageOfSamplesBasedOnAFixedNumberOfSamples,
  arithmeticAverageOfSamplesInATimePeriod,
  harmonicAverageOfSamplesInATimePeriod,
  medianOfSamplesInATimePeriod,
  movingAverageOfSamples
}



// WEBPACK FOOTER //
// ./src/app/models/enums/computationmethodtype.ts